import * as React from 'react';
import { useSignupMutation } from '../../generated/graphql';
import Signup from './Signup';
import * as Constants from '../../constants';

const SignupContainer = () => {
  const [signupFn, { data, error, loading }] = useSignupMutation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Failure: {String(error)}</div>;
  }

  if (data) {
    localStorage.setItem(Constants.userTokenLSKey, data.signup.token);
    return <div>
      Your account was created successfully, you can now <a href="/">use the app</a>!
      </div>;
  }

  return <Signup signupFn={signupFn} data={data}/>;
};

export default SignupContainer;
